var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextHotspotButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#E1251B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 10.8333C31 10.6123 30.9122 10.4004 30.7559 10.2441C30.5996 10.0878 30.3877 10 30.1667 10C29.9457 10 29.7337 10.0878 29.5774 10.2441C29.4211 10.4004 29.3333 10.6123 29.3333 10.8333V29.1667C29.3333 29.3877 29.4211 29.5996 29.5774 29.7559C29.7337 29.9122 29.9457 30 30.1667 30C30.3877 30 30.5996 29.9122 30.7559 29.7559C30.9122 29.5996 31 29.3877 31 29.1667V10.8333ZM11 11.67C10.9998 11.3641 11.0838 11.064 11.2428 10.8026C11.4018 10.5412 11.6297 10.3287 11.9015 10.1882C12.1733 10.0478 12.4785 9.98485 12.7837 10.0063C13.0888 10.0278 13.3822 10.1329 13.6317 10.31L25.2983 18.5817C25.515 18.735 25.6918 18.9379 25.8142 19.1735C25.9366 19.409 26.0009 19.6703 26.0019 19.9358C26.0029 20.2012 25.9405 20.463 25.8198 20.6994C25.6992 20.9358 25.5238 21.14 25.3083 21.295L13.6417 29.69C13.3928 29.8695 13.0992 29.9768 12.7932 30.0001C12.4872 30.0234 12.1807 29.9618 11.9075 29.822C11.6343 29.6822 11.405 29.4697 11.2449 29.2079C11.0847 28.9461 11 28.6452 11 28.3383V11.67ZM24.3333 19.9417L12.6667 11.67V28.3367L24.3333 19.9417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextHotspotButton);
export default __webpack_public_path__ + "static/media/nextHotspotButton.4a1a009789767122f7cf2c1dedf15bad.svg";
export { ForwardRef as ReactComponent };